module.exports = __webpack_public_path__ + "img/corneal-neovascularisation-3.6fb8334d.jpg";